<template>
  <div class="loginPage">
		<div class="loginComponent">
			<contact-form
			:preselectTopic="preselectTopic"
			></contact-form>
		</div>
  </div>
</template>

<script>

export default {
	name: 'ContactPage',
	props: {
		preselectTopic: String
	},
	metaInfo: {
		title: 'Contact Us'
	}
}
</script>
<style>
</style>
